import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const ReferencesSection = ({ references = [] }) => (
  <Card className="custom-shadow">
    <Card.Body>
      <h6 className="fw-bold mb-3">References</h6>
      {references.length > 0 ? (
        references.map((ref, i) => (
          <div
            key={i}
            className={`pb-3 ${
              i < references.length - 1 ? "border-bottom mb-3" : ""
            }`}
          >
            <Row>
              <Col>
                <label className="form-label text-xxs mb-0">Name</label>
                <h6 className="mb-0 fw-semibold text-sm">{ref.name}</h6>
              </Col>
              <Col>
                <label className="form-label text-xxs mb-0">Relationship</label>
                <h6 className="mb-0 fw-semibold text-sm">{ref.relationship}</h6>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <label className="form-label text-xxs mb-0">Email</label>
                <h6 className="mb-0 fw-semibold text-sm">{ref.email}</h6>
              </Col>
              <Col>
                <label className="form-label text-xxs mb-0">Phone</label>
                <h6 className="mb-0 fw-semibold text-sm">{ref.phone}</h6>
              </Col>
            </Row>
          </div>
        ))
      ) : (
        <p className="text-xs text-muted mb-0">No references available</p>
      )}
    </Card.Body>
  </Card>
);

export default ReferencesSection;
